(function () {
  'use strict';
  function start() {
    const section = document.getElementById('fv-product');
    const output = document.getElementById('fv-retail-reference');
    const select = document.getElementById('fv-variant');
    if (!section || !output || !select) return;
    function update() {
      const template = Array.from(section.querySelectorAll('template[data-fv-retail-variant]'))
        .find(item => item.dataset.fvRetailVariant === select.value);
      output.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
    }
    select.addEventListener('change', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
